import React, {  useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';

import { useNotification } from 'config/Notification';

import { fetchReportCompanies as fetchReportCompaniesService, updateRequestReport as updateRequestReportService} from 'services/modules/vapt/report';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import { 
    Autocomplete,
    Button,
    CircularProgress, 
    FormControl, 
    TextField 
} from '@mui/material';
import { fetchCompanyVAPTDimensions as fetchCompanyVAPTDimensionsService} from 'services/modules/vapt/data';


const RequestNewScanVAPT = ({ toggleRequestNewScan }) => {  
    // State Variables  
    const [category, setCategory] = useState(null);
    const [categoryError, setCategoryError] = useState('');
    const [companyError, setCompanyError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingBtn , setLoadingBtn] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [show, setShow] = useState(true);
    const [subCategory, setSubCategory] = useState([]);
    const [subCategoryError, setSubCategoryError] = useState('');
    
    //Redux Selectors
    const reportCompaniesContainer=useSelector((state)=>state.vaptReport.reportCompanies);
 
    //Notification
    const { openNotification } = useNotification();

    // Dispatch
    const dispatch = useDispatch();

    // Method to fetch the reports of the company
    const fetchReportData = async () => {
        try {
            setLoading(true);
            const params = {  project:"_id,name,domain",  limit:"null"}
            await dispatch(fetchReportCompaniesService(params))
           
        } 
        catch (error) {
            openNotification("Error fetching report:", 'error');
        } 
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
        savedCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedCompany])


    const savedCategories = async () => {
        if(!selectedCompany){
            return
        }
        let params = { company: selectedCompany?.id};
    
        try {
            let categories = await fetchCompanyVAPTDimensionsService({params});
            let data = categories.map((cat)=> cat);
            setSelectedCategories(data)
        } catch (error) {
            openNotification('Error fetching categories:', 'error');
        }
    };
    


    // This method handles the requesting new scan of reports
    const handleRequestReport = async () => {
        try {
            setLoadingBtn(true); 
            if(!selectedCompany){
                openNotification('Company field is required','error');
                return;
            }
            else if(!category){
                openNotification('Category field is required','error');
                return;
            }
            else if(!subCategory.category){
                openNotification('SubCategory field is required','error')
            }
            let payload = { domain: selectedCompany.domain, category: category?._id, subcategory :subCategory.category,companyId:selectedCompany?.id };
            const requestReport = await updateRequestReportService({payload})
           
            if ((requestReport.status === 201) || (requestReport.status === 200)){
                openNotification("Report request sent successfully.", 'success');
                setShow(false);
            }else{
                openNotification(requestReport.response.data.message,'error')
            }    
        } 
        catch (error) {
            openNotification('error while requesting report', 'error');
            setShow(false);
        } 
        finally {
            setLoadingBtn(false); 
        }
    };

    // Method closes the request new scan
    const closing = () => {
        setShow(false);
        toggleRequestNewScan();
    }

    return (
        <Modal show={show} onHide={closing} dialogClassName="modal-90w"  animation={false}>
            <Modal.Header className="space-between" closeButton>
                <Modal.Title className="report-modal">
                    <LibraryBooksIcon className="m-1" />
                    <h4 className="report-heading-1"> Generate a VAPT report for your website</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              
                    <>
                        <div>
                            <div className="report-modal-buttons">
                                <FormControl className='report-form'>
                                    <Autocomplete
                                        options={reportCompaniesContainer?.results || []}
                                        getOptionLabel={(company) => company.domain}
                                        value={selectedCompany}
                                        onChange={(event, newValue) => {
                                            setSelectedCompany(newValue);
                                            setCompanyError('');
                                        }}
                                        onBlur={() => {
                                            if (!selectedCompany) {
                                                setCompanyError('Company is required');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Company"
                                                variant="outlined"
                                                error={Boolean(companyError)}
                                                helperText={companyError}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </div>

                            <div className="report-modal-buttons my-2">
                                <FormControl className='report-form'>
                                    <Autocomplete
                                        options={selectedCategories.map((cat)=>cat) || []}
                                        getOptionLabel={(cat)=>cat.label}
                                        value={category}
                                        onChange={(event, newValue) => {
                                            setCategory(newValue);
                                            setCategoryError('');
                                        }}
                                        onBlur={() => {
                                            if (!category) {
                                                setCategoryError('Category is required');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Category"
                                                variant="outlined"
                                                error={Boolean(categoryError)}
                                                helperText={categoryError}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </div>


                            {
                                category && (
                                    <div className="report-modal-buttons my-2">
                                <FormControl className='report-form'>
                                    <Autocomplete
                                        options={category.subcategories || []}
                                        getOptionLabel={(cat)=>cat.category}
                                        value={subCategory?.category}
                                        onChange={(event, newValue) => {
                                            setSubCategory(newValue);
                                            setSubCategoryError('');
                                        }}
                                        onBlur={() => {
                                            if (!subCategory) {
                                                setSubCategoryError('SubCategory is required');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="SubCategory"
                                                variant="outlined"
                                                error={Boolean(subCategoryError)}
                                                helperText={subCategoryError}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </div>

                                )
                            }

                            <div className="report-modal-buttons">
                               <Button variant="outlined" className="reqreport-btn" onClick={handleRequestReport} disabled={loading}>
                                    {loadingBtn ? (
                                        <CircularProgress  /> 
                                    ) : (
                                        <>
                                            <LibraryBooksIcon className="m-1" /> Request report
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </>
                
            </Modal.Body>
        </Modal>
    )
}
export default RequestNewScanVAPT;